import { FilterOptionInterface } from "../interfaces/filters-config-interface";

export type TFilterOptions = "IN" | "IS" | "IS_NOT" | "LIKE" | "GREATER_THAN" | "LESS_THAN" | "LESS_THAN_OR_EQ" | "GREATER_THAN_OR_EQ" | "ALL";

export const filterOptions: Record<TFilterOptions, FilterOptionInterface> = {
  IN: { key: "IN", label: "In" },
  IS: { key: "IS", label: "Is" },
  IS_NOT: { key: "IS_NOT", label: "Is Not" },
  LIKE: { key: "LIKE", label: "Like" },
  GREATER_THAN: { key: "GREATER_THAN", label: "Greater Than" },
  LESS_THAN: { key: "LESS_THAN", label: "Less Than" },
  LESS_THAN_OR_EQ: { key: "LESS_THAN_OR_EQ", label: "Less Than Or equal" },
  GREATER_THAN_OR_EQ: { key: "GREATER_THAN_OR_EQ", label: "Greater Than Or equal" },
  ALL: { key: "ALL", label: "All" },
};
